import Dropdown, { DropdownItem, DropdownMultiProps, DropdownProps } from '@/components/Dropdown';
import { FieldProps, fieldWrapper } from '@/components/Field';
import { ReactNode, useMemo } from 'react';

import { properCase } from '@/utils';

export type EnumDropdownProps = { enum: Record<string, string> } & Omit<DropdownProps, 'items'>;
export type EnumDropdownMultiProps = { enum: Record<string, string> } & Omit<DropdownMultiProps, 'items'>;

const EnumDropdown = ({ enum: enumOptions, ...dropdownProps }: EnumDropdownProps): ReactNode => {
  const items = useMemo(
    (): DropdownItem[] =>
      Object.entries(enumOptions).map(
        ([label, value]: [string, string]): DropdownItem => ({
          label,
          value,
          keywords: [label, value],
        })
      ),
    [enumOptions]
  );

  return <Dropdown {...dropdownProps} items={items} />;
};
export const EnumDropdownMulti = ({ enum: enumOptions, ...dropdownProps }: EnumDropdownMultiProps): ReactNode => {
  const items = useMemo(
    (): DropdownItem[] =>
      Object.entries(enumOptions).map(
        ([label, value]: [string, string]): DropdownItem => ({
          label,
          value,
          keywords: [label, value],
        })
      ),
    [enumOptions]
  );
  return <Dropdown.Multi {...dropdownProps} items={items} />;
};
EnumDropdown.Multi = EnumDropdownMulti;

export default EnumDropdown;
export type EnumDropdownFieldProps = EnumDropdownProps & Partial<Omit<FieldProps, 'onChange'>>;

export const EnumDropdownField = fieldWrapper<EnumDropdownProps>(EnumDropdown);

export const getItemsFromEnum = (enumType): {} =>
  Object.entries(enumType).reduce(
    (acc: {}, [key, value]: [string, typeof enumType]): {} => ({
      ...acc,
      [properCase(key.replace(/_/g, ' ')).replace('And', 'and')]: value,
    }),
    {}
  );

export const getItemsFromEnumValues = (enumType): {} =>
  Object.entries(enumType).reduce(
    (acc: {}, [, value]: [string, typeof enumType]): {} => ({
      ...acc,
      [properCase(value.replace(/_/g, ' ')).replace('And', 'and')]: value,
    }),
    {}
  );
